/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** 認証済みユーザー情報 */
export interface AuthenticatedUser {
  /**
   * 企業ID
   * @example "2"
   */
  kuchikomiEnterpriseId: string;
  /**
   * ユーザー表示名
   * @example "サンプル太郎"
   */
  displayName: string;
  /**
   * ユーザーアイコン画像
   * @example "https://picsum.photos/200"
   */
  iconUrl: string;
  /**
   * スタッフかどうか
   * @example false
   */
  isStaff: boolean;
}

/** 事業 */
export interface Business {
  /** 事業概要モデル */
  slideAbstract: SlideBusinessAbstract;
  /** 3C分析モデル */
  slideThreeC: SlideThreeC;
  /** 投資計画モデル */
  slideInvestmentPlan: SlideInvestmentPlan;
  /** 実行計画&必要なリソースモデル */
  slideExecutionPlan: SlideExecutionPlan;
  /** FAQ・懸念点まとめモデル */
  slideFaq: SlideFaq;
  /** オススメ共創パートナー企業モデル */
  slidePartners: SlidePartners;
}

/** 事業概要モデル */
export interface SlideBusinessAbstract {
  /**
   * 事業概要ID
   * @example "1"
   */
  id: string;
  /** @example "廃棄プラスチックを活用したエコパッケージ開発" */
  projectName: string;
  /** @example "https://picsum.photos/200" */
  thumbnailUrl?: string | null;
  sections: {
    /**
     * 市場背景の説明
     * @example "環境規制の強化や消費者の意識変化により、環境配慮型パッケージの需要が急速に拡大しています。特に欧州やアジアでの脱プラ規制により、企業には対応が迫られており、サステナブルな商品を選ぶ消費者も増加しています。この動きは今後さらに加速し、エコパッケージ市場は中長期的に確実な成長が見込まれる分野となっています。"
     */
    marketBackground: string;
    /**
     * 競合分析の説明
     * @example "多くの企業がリサイクル素材やバイオマスパッケージの導入を進めていますが、廃プラスチックを活用した一貫型の取り組みはまだ限定的です。当社は、素材回収から製品化までのプロセスを自社主導で構築することで、他社との差別化とブランドの信頼性向上を目指します。"
     */
    competitorAnalysis: string;
    /**
     * ビジネスチャンスの説明
     * @example "エコパッケージ市場は年平均〇〇％の成長率で拡大しており、特に食品・化粧品・日用品など幅広い分野で需要が高まっています。政策支援や補助金制度も整備されつつあり、新規参入しやすい環境が整っています。%の成長が見込まれています。"
     */
    businessChance: string;
    /**
     * 事業内容の1つ目の説明
     * @example "当社は、廃プラスチックを回収・再資源化し、環境配慮型の新素材としてパッケージを開発します。これを自社製品に導入することでブランド価値を向上させ、同時に他社への提供も行い販路を拡大。BtoBではサステナブル志向の企業、BtoCではエコ意識の高い消費者をターゲットに国内外展開を進めます。"
     */
    businessContentFirst: string;
    /**
     * 事業内容の2つ目の説明
     * @example "また、自治体や企業との共同マーケティングや共同開発を活用し、認知拡大と技術力向上を図ります。回収から販売までをつなぐ循環型ビジネスモデルの構築を通じて、社会課題の解決と収益性の両立を目指します。"
     */
    businessContentSecond: string;
  };
}

/** 3C分析モデル */
export interface SlideThreeC {
  /**
   * 3C分析ID
   * @example "1"
   */
  id: string;
  /** Customer（市場・顧客） */
  customer: {
    /**
     * ニーズの説明
     * @example "環境負荷の少ない商品を選ぶ傾向が強まっており、特にミレニアル世代・Z世代を中心に「企業の環境配慮」に敏感。"
     */
    needs: string;
    /**
     * ターゲット層の1つ目の説明
     * @example "BtoB：食品・化粧品・アパレルメーカーなど環境配慮型パッケージを導入したい企業。"
     */
    targetFirst: string;
    /**
     * ターゲット層の2つ目の説明
     * @example "BtoC：エコ意識の高い生活者層、特にサステナブル志向の購買行動をとる都市部在住者。"
     */
    targetSecond: string;
    /**
     * 市場トレンドの1つ目の説明
     * @example "世界のエコパッケージ市場は年平均○○％（例：6～8％）で成長中。"
     */
    marketTrendFirst: string;
    /**
     * 市場トレンドの2つ目の説明
     * @example "小売店やEC業者による脱プラ・紙素材からのシフトも拡大中。"
     */
    marketTrendSecond: string;
  };
  /** Competitor（競合） */
  competitor: {
    /**
     * 主要競合の1つ目の説明
     * @example "リサイクルPETやバイオプラスチックを使った大手パッケージ企業。"
     */
    mainCompetitorFirst: string;
    /**
     * 主要競合の2つ目の説明
     * @example "海外スタートアップによる革新的エコ素材（例：海藻ベース、きのこ由来など）。"
     */
    mainCompetitorSecond: string;
    /**
     * 優位性の1つ目の説明
     * @example "競合はすでに技術開発・ブランド展開を進めている。"
     */
    advantageFirst: string;
    /**
     * 優位性の2つ目の説明
     * @example "価格競争力・大量供給体制・流通ルートなどで先行している場合も多い。"
     */
    advantageSecond: string;
    /**
     * 差別化のヒントの1つ目の説明
     * @example "「廃棄プラの回収→再資源化→新素材開発」まで自社で一貫対応する循環モデル。"
     */
    differentiationFirst: string;
    /**
     * 差別化のヒントの2つ目の説明
     * @example "CO2削減効果・トレーサビリティの明示。"
     */
    differentiationSecond: string;
  };
  /** Company（自社） */
  company: {
    /**
     * 自社の強みの1つ目の説明
     * @example "サステナブルな価値観を持つ企業文化。"
     */
    strengthFirst: string;
    /**
     * 自社の強みの2つ目の説明
     * @example "自社ブランド製品への導入により即時の活用とPRが可能。"
     */
    strengthSecond: string;
    /**
     * 自社の強みの3つ目の説明
     * @example "協業企業との関係性（地域のリサイクル企業・大学との連携など）。"
     */
    strengthThird: string;
    /**
     * リソースの1つ目の説明
     * @example "既存の製造・販売チャネルを活用可能。"
     */
    resourceFirst: string;
    /**
     * リソースの2つ目の説明
     * @example "SDGsやCSRに関心の高い既存取引先。"
     */
    resourceSecond: string;
    /**
     * 今後の戦略の1つ目の説明
     * @example "BtoBでは大手ブランドとのプロジェクトを開発。"
     */
    strategyFirst: string;
    /**
     * 今後の戦略の2つ目の説明
     * @example "BtoCではストーリー性のある商品展開＋SNS等での啓発。"
     */
    strategySecond: string;
    /**
     * 今後の戦略の3つ目の説明
     * @example "国内外展示会やSDGs関連イベントでのPR。"
     */
    strategyThird: string;
  };
}

/** 投資計画モデル */
export interface SlideInvestmentPlan {
  /**
   * 投資計画ID
   * @example "1"
   */
  id: string;
  /**
   * 収益構造の説明
   * @example "主力製品である生分解性パッケージの販売により、食品・化粧品業界を中心に安定した収益基盤を構築します。初年度500億円の売上を目標とし、3年目には1,000億円規模への拡大を計画しています。また、SDGsコンサルティングサービスにより、企業のサステナビリティ推進を支援し、多角的な収益源を確保します。"
   */
  profitStructure: string;
  /**
   * 収益項目のJSON配列
   * @example "[{"label":"エコパッケージ販売売上","value":"年間850億円"},{"label":"新規顧客獲得数","value":"年間120社"},{"label":"コスト削減効果","value":"年間65億円"},{"label":"投資回収期間","value":"期間3年以内"}]"
   */
  profitStructureItems: string;
  /**
   * キャッシュフロー計画の説明
   * @example "初年度は設備投資により一時的な赤字となりますが、2年目から黒字転換し、3年目には営業利益率12%を達成予定です。5年間累計で営業利益600億円、投資回収率180%を見込み、持続可能な成長軌道を描きます。"
   */
  cashFlow: string;
  /**
   * キャッシュフロー項目のJSON配列
   * @example "[{"year":"1年目","sales":"420億円","operatingIncome":"-35億円","recovery":"25%"},{"year":"2年目","sales":"780億円","operatingIncome":"95億円","recovery":"65%"},{"year":"3年目","sales":"1,150億円","operatingIncome":"185億円","recovery":"90%"}]"
   */
  cashFlowItems: string;
  /**
   * 初期投資と財務計画の説明
   * @example "総投資額3,120万円のうち、自己資金50%、銀行融資40%、補助金10%で資金調達を行います。研究開発に40%、生産設備に35%、マーケティングに15%、人材育成に10%の配分で効率的な事業展開を図ります。"
   */
  financialPlan: string;
  /**
   * 財務計画項目のJSON配列
   * @example "[{"label":"研究開発費","value":"1,250万円"},{"label":"生産設備導入費","value":"1,090万円"},{"label":"マーケティング費用","value":"470万円"},{"label":"人材採用・教育","value":"200万円"},{"label":"物流最適化","value":"110万円"},{"label":"合計","value":"3,120万円"}]"
   */
  financialPlanItems: string;
}

/** 実行計画&必要なリソースモデル */
export interface SlideExecutionPlan {
  /**
   * 実行計画スライドID
   * @example "1"
   */
  id: string;
  /**
   * 必要なリソース説明文
   * @example "本プロジェクトの実行には、技術開発チーム（エンジニア5名、デザイナー2名）、マーケティングチーム（3名）、営業チーム（4名）の計14名の人員が必要です。初期投資として3,000万円、運転資金として月額500万円を見込んでいます。また、製造設備の確保、原材料の安定供給体制の構築、販売チャネルの開拓が重要な成功要因となります。"
   */
  resource: string;
  /**
   * 最大期間数（1〜24）
   * @min 1
   * @max 24
   * @example 18
   */
  maxPeriod: number;
  /**
   * スケジュール項目のJSON配列
   * @example "[{"label":"市場調査・要件定義","startPeriod":1,"endPeriod":3},{"label":"プロトタイプ開発","startPeriod":3,"endPeriod":6},{"label":"実証実験","startPeriod":5,"endPeriod":8},{"label":"量産体制構築","startPeriod":7,"endPeriod":12},{"label":"マーケティング・販売開始","startPeriod":10,"endPeriod":18}]"
   */
  scheduleItems: string;
}

/** FAQ・懸念点まとめモデル */
export interface SlideFaq {
  /**
   * FAQ・懸念点まとめID
   * @example "1"
   */
  id: string;
  /**
   * 懸念点と対応策のJSON配列
   * @example "[{"label":"環境への実質的な効果が薄い","value":"第三者機関による環境影響評価を定期実施し、削減効果を数値で検証。年次レポートで透明性を確保します。"},{"label":"既存プラスチック業界からの反発","value":"競合他社との協業を積極推進し、業界全体の持続可能な移行を支援。Win-Winの関係構築を目指します。"},{"label":"製造コストが高く価格競争力不足","value":"量産効果とサプライチェーン最適化により製造コストを30%削減。補助金制度も活用して価格優位性を確保します。"},{"label":"消費者の環境意識不足","value":"教育キャンペーンとインフルエンサー連携で環境意識を向上。使いやすさも重視した製品設計で普及を促進します。"}]"
   */
  concerns: string;
  /**
   * FAQ項目のJSON配列
   * @example "[{"label":"どのくらいの期間で投資回収が可能ですか？","value":"3年以内の投資回収を目標とし、市場拡大により2年半での回収も見込まれます。キャッシュフローを重視した戦略です。"},{"label":"競合との差別化要素は何ですか？","value":"特許技術の生分解性素材技術、高品質パッケージ技術、カスタマイズ対応が可能な製品です。"},{"label":"市場規模はどの程度ですか？","value":"環境意識の高い消費者、政府機関、小売業者、消費財メーカーをメインターゲットに設定し、総市場規模1兆円を想定しています。"},{"label":"事業リスクはどのように管理する？","value":"原材料の調達先を多様化し、品質変更リスクを軽減。環境変動に対応するため、異なる業界との連携を強化します。"},{"label":"組織や外部資源の活用予定は？","value":"SDGs市場の専門家の雇用推進及び外部コンサルタントの活用を行う。また、ベンチャーキャピタルやESG投資ファンドとの提携を検討。"}]"
   */
  faqs: string;
}

/** オススメ共創パートナー企業モデル */
export interface SlidePartners {
  /**
   * パートナー企業スライドID
   * @example "1"
   */
  id: string;
  /**
   * パートナー企業のJSON配列
   * @example "[{"thumbnailUrl":"https://picsum.photos/200","enterpriseName":"富士通株式会社","industryCategory":"製造業","evaluation":5,"enterpriseFeature":"廃プラスチックの回収・再資源化技術を持ち、高品質なリサイクル素材の提供に強みを持つ。独自の化学リサイクル技術を用いた高純度のプラスチック再生が可能。政府や大手メーカーとの連携実績あり。","advantage":"安定供給が可能であり、環境負荷を大幅に削減。補助金活用によるコスト低減も期待できる。"},{"thumbnailUrl":"https://picsum.photos/200","enterpriseName":"エコテクノロジー株式会社","industryCategory":"環境技術","evaluation":3,"enterpriseFeature":"エコパッケージの開発・製造に特化し、バイオプラスチックや再生素材を用いたカスタムパッケージの設計に対応。低コストかつ高機能な包装を提供。","advantage":"デザイン性と機能性を両立したパッケージの開発が可能。市場ニーズに応じた製品カスタマイズが柔軟にできる。"},{"thumbnailUrl":"https://picsum.photos/200","enterpriseName":"グリーンソリューション株式会社","industryCategory":"化学","evaluation":4,"enterpriseFeature":"生分解性プラスチックの研究開発に特化した企業。独自の素材技術により、従来品と同等の耐久性を保ちつつ、自然環境での分解が可能な素材を開発。食品包装から工業用途まで幅広い展開。","advantage":"技術革新により競合優位性を確保。特許技術による参入障壁で安定的な事業展開が期待できる。"},{"thumbnailUrl":"https://picsum.photos/200","enterpriseName":"物流イノベーション株式会社","industryCategory":"物流","evaluation":4,"enterpriseFeature":"環境配慮型の物流システムを構築し、再利用可能な包装材と最適化された配送ルートで環境負荷を最小限に抑える。AIを活用した効率的な物流管理システムを導入。","advantage":"全国規模の配送ネットワークを活用し、環境に配慮した物流サービスを提供。コスト削減と環境保護の両立を実現。"},{"thumbnailUrl":"https://picsum.photos/200","enterpriseName":"デジタルソリューションズ株式会社","industryCategory":"IT","evaluation":5,"enterpriseFeature":"IoTセンサーとブロックチェーン技術を組み合わせた資源トラッキングシステムを開発。リサイクル材の品質保証と追跡を可能にする先進的なプラットフォームを提供。","advantage":"デジタル技術による透明性の確保と品質管理の強化。データ分析による継続的な改善提案が可能。"},{"thumbnailUrl":"https://picsum.photos/200","enterpriseName":"サステナブル商事株式会社","industryCategory":"商社","evaluation":3,"enterpriseFeature":"環境配慮型製品の国際取引に特化し、グローバルなサプライチェーンネットワークを保有。サステナビリティに関する国際認証取得支援も行う。","advantage":"世界各国の環境規制に対応した製品供給が可能。国際市場への展開をサポートし、新規販路開拓を支援。"}]"
   */
  partners: string;
}

/** 企業情報 */
export interface EnterpriseSummary {
  /** @example 2 */
  id: string;
  /** @example "サンプル株式会社（EnterpriseSummary:）" */
  name: string;
  /** @example "共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。共創サンプル株式会社です。" */
  description?: string | null;
  /** @example "サンプル姓" */
  delegateLastName?: string | null;
  /** @example "サンプル名" */
  delegateFirstName?: string | null;
  /** @example "サンプル役職" */
  delegatePosition?: string | null;
  /** @example "山田太郎" */
  responsiblePersonName?: string | null;
  /** @example 90 */
  matchingRate: number;
  /** @example "大規模(301人以上)" */
  employeeCount?: string | null;
  /**
   * @format date-time:YYYY-MM-DD HH:mm:ss
   * @example "2024-03-01"
   */
  establishDate?: string | null;
  /** @example "000-0000" */
  postCode?: string | null;
  /** @example "サンプル住所0-00-0" */
  address?: string | null;
  /** @example "大阪府足跡" */
  prefecture?: string | null;
  /** @example "000-0000-000" */
  tel?: string | null;
  /** @example "1234" */
  stockCode?: string | null;
  /** @example 100000000 */
  capitalPrice?: number | null;
  /** @example 100 */
  employeeNum?: number | null;
  /** @example {"code":"manufacture","value":"製造業"} */
  industryParentCode: EnumData;
  industryChildCode: EnumData;
  enterpriseCode?: EnumData | null;
  /** @example [{"code":"agricultural","value":"農業、林業","child":{"code":"crop_production","value":"耕種農業"}}] */
  businessCode?:
    | {
        code?: string;
        value?: string;
        child?: {
          code?: string;
          value?: string;
        };
      }[]
    | null;
  /** @example [{"code":"1","value":"貧困をなくそう"},{"code":"2","value":"飢餓をゼロに"}] */
  sdgsCategory?: EnumData[] | null;
  /** @example "https://picsum.photos/200" */
  logoUrl: string;
  /** @example "https://picsum.photos/200" */
  officialUrl?: string | null;
  /** @example "https://picsum.photos/200" */
  twitterUrl?: string | null;
  /** @example "https://picsum.photos/200" */
  facebookUrl?: string | null;
  /** @example "https://picsum.photos/200" */
  lineUrl?: string | null;
  /** @example "https://picsum.photos/200" */
  tiktokUrl?: string | null;
  /**
   * 売上
   * @example "2025年度: 2,000億円"
   */
  sales?: string | null;
  /** @example false */
  isFavorited?: boolean;
  /** @example false */
  isOwn: boolean;
}

export interface ChatRoom {
  /**
   * チャットID
   * @example 1
   */
  id: number;
  /**
   * チャット相手の口コミ企業ID
   * @example 1
   */
  partnerId: number;
  /**
   * 企業名
   * @example "エコパワー株式会社"
   */
  name: string;
  /**
   * 企業ロゴ画像URL
   * @example "https://via.placeholder.com/40x40/FF6B6B/FFFFFF?text=E"
   */
  logo: string;
  /**
   * ステータス
   * @example "limited"
   */
  status: "limited" | "full";
  /**
   * Firebase上のチャットルームID
   * @example "jksjlfiajildsa"
   */
  firebaseRoomId: string;
  members: {
    /** @example "エコパワー株式会社" */
    name?: string;
    /** @example "https://via.placeholder.com/40x40/FF6B6B/FFFFFF?text=E" */
    logo?: string;
    /**
     * 自分のメッセージかどうか
     * @example false
     */
    isOwn?: boolean;
  }[];
  lastMessage: {
    /** @example "おはようございます。先日お話しした再生可能エネルギープロジェクトの件ですが、弊社内で検討した結果、ぜひ協力させていただきたいと思います。" */
    content?: string | null;
    /**
     * 送信時刻
     * @example "2025-10-10 10:15:00"
     */
    sentAt?: string | null;
  };
}

export interface ChatMessage {
  /**
   * メッセージID
   * @example "1"
   */
  id: string;
  /**
   * 送信者ID
   * @example "other"
   */
  senderId: string;
  /**
   * 受信者ID
   * @example "me"
   */
  receiverId: string;
  /**
   * メッセージ内容
   * @example "おはようございます。先日お話しした再生可能エネルギープロジェクトの件ですが、弊社内で検討した結果、ぜひ協力させていただきたいと思います。"
   */
  content: string;
  /**
   * 送信時刻
   * @example "10:15 AM"
   */
  timestamp: string;
  /**
   * 自分のメッセージかどうか
   * @example false
   */
  isOwn: boolean;
  /** 添付ファイル情報 */
  attachment?: {
    /**
     * ファイル名
     * @example "再生可能エネルギープロジェクト概要.pdf"
     */
    name?: string;
    /**
     * ファイルURL
     * @example "#"
     */
    url?: string;
  };
}

/** 関連企業情報 */
export interface RelatedEnterprise {
  /** @example 3 */
  id: string;
  /** @example "エコパワー株式会社" */
  name: string;
  /** @example "https://picsum.photos/200" */
  logoUrl: string;
  /** @example {"code":"manufacture","value":"製造業"} */
  industryParentCode?: EnumData;
}

/**
 * アクセストークン
 * @example "Fghasdgkl9874r4#sgsl#dgag00ldkfgwe"
 */
export type AccessToken = string;

export interface EnumData {
  code: string;
  value: string;
}

/** お問い合わせリクエスト */
export interface ContactRequest {
  /**
   * 企業名・団体名
   * @example "株式会社サンプル"
   */
  enterpriseName?: string | null;
  /**
   * 部署名
   * @example "開発部"
   */
  departmentName?: string | null;
  /**
   * 名前
   * @example "山田太郎"
   */
  name: string;
  /**
   * メールアドレス
   * @format email
   * @example "yamada@example.com"
   */
  email: string;
  /**
   * 電話番号
   * @example "03-1234-5678"
   */
  tel?: string | null;
  /**
   * 件名
   * @example "サービスについての問い合わせ"
   */
  subject: string;
  /**
   * お問い合わせ本文
   * @example "お問い合わせ内容をここに記載します。"
   */
  message: string;
}

/** FAQアイテム */
export interface FaqItem {
  /**
   * FAQ ID
   * @example 1
   */
  id: number;
  /**
   * カテゴリー名
   * @example "共創プラットフォームについて"
   */
  category: string;
  /**
   * 質問
   * @example "共創プラットフォームとは何ですか？"
   */
  question: string;
  /**
   * 回答
   * @example "SDGs達成に向けて企業同士が連携し、新しいビジネスや社会課題解決に取り組むためのマッチングプラットフォームです。"
   */
  answer: string;
  /**
   * 表示順
   * @example 1
   */
  sort_order: number;
}

/** パートナー募集情報 */
export interface PartnerRecruitment {
  /**
   * パートナー募集ID
   * @example 1
   */
  id: number;
  /**
   * タイトル
   * @example "SDGs環境技術パートナー募集"
   */
  title: string;
  /**
   * 本文（HTML）
   * @example "<p>当社では、持続可能な環境技術の開発において、革新的なソリューションを共に創造していただけるパートナー企業を募集しています。</p>"
   */
  description: string;
  /**
   * 応募要件
   * @example "・環境技術分野での事業実績がある企業\n・技術開発への積極的な投資意欲"
   */
  requirements?: string | null;
  /**
   * 法的事項
   * @example "・知的財産権の共有に関する契約締結\n・NDAの締結"
   */
  legal_matters?: string | null;
  /**
   * サムネイル画像URL
   * @example "https://via.placeholder.com/300x200?text=Environment+Tech"
   */
  thumbnail_url?: string | null;
  /**
   * ステータス
   * @example "published"
   */
  status: "draft" | "scheduled" | "published";
  /**
   * 公開予定日
   * @format date-time
   * @example "2025-03-15T09:00:00Z"
   */
  scheduled_date?: string | null;
  /**
   * 自分の募集かどうか
   * @example false
   */
  is_own_recruitment: boolean;
  /**
   * SDGsカテゴリー
   * @example ["7","13","14","15"]
   */
  sdgs_categories?: string[] | null;
  /** 企業情報 */
  enterprise: EnterpriseSummary;
  /**
   * 作成日時
   * @format date-time
   * @example "2025-01-15T09:00:00Z"
   */
  created_at: string;
  /**
   * 更新日時
   * @format date-time
   * @example "2025-01-15T09:00:00Z"
   */
  updated_at: string;
}

export interface SuccessResponse {
  /** @example "success" */
  result?: "success";
}

/** バリデーションエラー(422エラー)の時に返却される共通のレスポンス */
export interface ValidationErrorResponse {
  /** @example "入力内容に誤りがあります。" */
  message?: string;
  /** @example {"email":["メールアドレスは必須です。","メールアドレスの形式が正しくありません。"],"password":["パスワードは必須です。","パスワードは8文字以上で入力してください。"]} */
  errors?: {
    additionalProperties?: string[];
  }[];
}

/** 企業詳細情報 */
export interface EnterpriseDetail {
  /**
   * クチコミ企業ID
   * @example "123"
   */
  kuchikomiEnterpriseId: string;
  /**
   * 自分の企業かどうか
   * @example false
   */
  isOwn: boolean;
  /** 企業概要情報 */
  summary: {
    /**
     * バナー画像URL
     * @example "https://example.com/banner.jpg"
     */
    bannerImageUrl: string | null;
    /** 共創トップ画像情報 */
    topImages?: {
      images?: {
        /**
         * 共創トップ画像のID
         * @example 1
         */
        id: number | null;
        /**
         * 画像URL
         * @example "https://picsum.photos/800/600"
         */
        imageUrl: string;
        /**
         * 表示順
         * @example 1
         */
        sortOrder: number;
      }[];
    };
    /**
     * 企業概要
     * @example "当社は環境技術分野において30年以上の実績を持つ企業です。持続可能な社会の実現に向けて、革新的なソリューションを提供しています。"
     */
    companyProfile: string | null;
    /**
     * 自社特徴
     * @example "<p><strong>技術革新力1</strong>により、業界をリードする環境技術を開発しています。<a href="https://example.com/tech" class="text-main-green underline">技術詳細</a></p><ul><li>特許技術20件以上</li><li>研究開発への継続投資</li><li>大学との共同研究</li></ul>"
     */
    companyFeature: string | null;
    /**
     * 提供リソース
     * @example "<p><strong>技術支援1</strong>として、専門的なコンサルティングと技術移転を提供します。</p><ul><li>技術コンサルティング</li><li>共同研究開発</li><li>人材育成支援</li></ul>"
     */
    providedResource: string | null;
    /**
     * 主要顧客
     * @example "<p><strong>主要顧客1</strong>には大手製造業を中心に、長期的なパートナーシップを構築しています。</p><ul><li>自動車メーカー</li><li>電機メーカー</li><li>化学メーカー</li></ul>"
     */
    majorCustomer: string | null;
    /**
     * 株主
     * @example "<p><strong>株主構成1</strong>は技術志向の投資家が中心で、長期的な成長を支援しています。</p><ul><li>創業者グループ 40%</li><li>機関投資家 35%</li><li>事業会社 25%</li></ul>"
     */
    shareholder: string | null;
    /** オープンイノベーション実績情報 */
    openInnovationAchievements: {
      /** @example [{"id":1,"imageUrl":"https://picsum.photos/200","content":"<p><strong>大手電力会社との協力</strong>により、次世代太陽光発電システムの開発に成功しました。高効率かつ低コストなシステムとして、市場に大きなインパクトを与えています。<a href=\"https://example.com/solar-project\" class=\"text-main-green underline\">プロジェクト詳細</a></p><ul><li>発電効率20%向上</li><li>製造コスト30%削減</li><li>年間100MWの導入実績</li></ul>"},{"id":2,"imageUrl":"https://picsum.photos/200","content":"<p><strong>大学研究機関との連携</strong>により、新型蓄電池技術の開発に成功しました。従来比2倍の容量と3倍の寿命を実現し、再生可能エネルギーの安定供給に貢献しています。<a href=\"https://example.com/battery-project\" class=\"text-main-green underline\">技術詳細</a></p><ul><li>容量2倍の実現</li><li>寿命3倍の延長</li><li>安全性の大幅向上</li></ul>"},{"id":3,"imageUrl":"https://picsum.photos/200","content":"<p><strong>自治体との協働</strong>により、地域全体のスマートグリッド構築を実現しました。エネルギーの最適配分により、地域の脱炭素化に大きく貢献しています。<a href=\"https://example.com/smart-grid\" class=\"text-main-green underline\">プロジェクト概要</a></p><ul><li>地域全体の電力最適化</li><li>CO2排出量50%削減</li><li>災害時の電力供給安定化</li></ul>"}] */
      achievements: {
        /**
         * オープンイノベーション実績のID
         * @example 1
         */
        id: number | null;
        /**
         * 実績画像のURL
         * @example "https://picsum.photos/200"
         */
        imageUrl: string | null;
        /**
         * HTML形式のオープンイノベーション実績コンテンツ
         * @example "<p><strong>大手電力会社との協力</strong>により、次世代太陽光発電システムの開発に成功しました。高効率かつ低コストなシステムとして、市場に大きなインパクトを与えています。<a href="https://example.com/solar-project" class="text-main-green underline">プロジェクト詳細</a></p><ul><li>発電効率20%向上</li><li>製造コスト30%削減</li><li>年間100MWの導入実績</li></ul>"
         */
        content: string | null;
      }[];
    };
  };
  /** 共創情報 */
  coCreationInfo: {
    /**
     * 共創タイトル
     * @example "共創パートナー募集1"
     */
    title: string | null;
    /**
     * 共創タイトルの内容
     * @example "<p><strong>共創内容1</strong>: 環境技術の共同開発を通じて、新たな価値創造を目指します。<a href="https://example.com/cocreation" class="text-main-green underline">共創詳細</a></p>"
     */
    content: string | null;
    /**
     * 解決したい課題
     * @example "<p><strong>課題1</strong>: 気候変動対策として、CO2排出量削減技術の開発が急務となっています。</p><ul><li>製造工程の脱炭素化</li><li>エネルギー使用量削減</li><li>廃棄物削減</li></ul>"
     */
    issue: string | null;
    /**
     * 共創で実現したいこと
     * @example "<p><strong>実現目標1</strong>: 次世代環境技術の実用化により、持続可能な製造システムを構築します。</p><ul><li>CO2排出50%削減</li><li>エネルギー効率30%向上</li><li>廃棄物ゼロ実現</li></ul>"
     */
    goal: string | null;
    /**
     * 求めている条件
     * @example "<ul><li>環境技術分野での3年以上の経験</li><li>研究開発チーム3名以上</li><li>プロトタイプ開発実績</li><li>年間1000万円以上の開発予算</li></ul>"
     */
    requirement: string | null;
  };
  /** SDGs取り組み情報 */
  sdgsInitiatives: {
    /**
     * 再生可能エネルギーの普及
     * @example "<p><strong>再生エネルギー普及1</strong>に向けて、太陽光・風力発電システムの効率化技術を開発しています。</p><ul><li>発電効率向上技術</li><li>蓄電システム開発</li><li>スマートグリッド連携</li></ul>"
     */
    renewableEnergy: string | null;
    /**
     * エネルギー効率化技術の開発
     * @example "<p><strong>エネルギー効率化1</strong>技術により、産業プロセスの省エネルギー化を実現します。</p><ul><li>AI制御システム</li><li>IoTセンサー活用</li><li>プロセス最適化</li></ul>"
     */
    energyEfficiency: string | null;
    /**
     * 環境教育プログラムの実施
     * @example "<p><strong>環境教育1</strong>プログラムを通じて、次世代の環境意識向上に貢献しています。</p><ul><li>学校向けプログラム</li><li>企業研修</li><li>一般向けセミナー</li></ul>"
     */
    environmentalEducation: string | null;
    /**
     * SDGsへの取り組み補足情報
     * @example "<p><strong>SDGs取り組み1</strong>として、目標7・9・13を重点的に推進し、技術革新を通じて持続可能な社会の実現に貢献しています。</p>"
     */
    sdgsInfo: string | null;
    /**
     * SDGsカテゴリー情報
     * @example [{"code":"7","value":"目標7: エネルギーをみんなにそしてクリーンに"},{"code":"9","value":"目標9: 産業と技術革新の基盤をつくろう"},{"code":"13","value":"目標13: 気候変動に具体的な対策を"}]
     */
    sdgsCategories: EnumData[] | null;
  };
  /** 本掲載の責任者情報 */
  publicationResponsibility: {
    /**
     * 部署名
     * @example "法人向け放送ソリューション事業部責任者"
     */
    departmentName: string | null;
    /** 責任者情報 */
    responsiblePerson: {
      /**
       * 責任者姓
       * @example "サンプル姓"
       */
      lastName: string | null;
      /**
       * 責任者名
       * @example "サンプル名責任者"
       */
      firstName: string | null;
      /**
       * 責任者役職
       * @example "サンプル役職責任者"
       */
      position: string | null;
      /**
       * プロフィール画像URL
       * @example "https://picsum.photos/200"
       */
      profileImg: string | null;
      /**
       * 自己紹介(経歴)
       * @example "10年以上の業界経験を持ち、環境技術分野での専門知識を活かして、持続可能な社会の実現に貢献しています。"
       */
      introduction: string | null;
      /**
       * ミッション
       * @example "技術革新を通じて、次世代に美しい地球環境を残すことが私たちの使命です。"
       */
      mission: string | null;
      /**
       * コメント
       * @example "共創パートナーの皆様と共に、新たな価値創造に挑戦していきたいと考えています。"
       */
      comment: string | null;
    };
    /**
     * 部署説明
     * @example "部署の説明文を100文字で作成1234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890"
     */
    departmentDescription: string | null;
  };
  /**
   * 探したいタグ
   * @example "sample"
   */
  searchIndustryCategories?: {
    /**
     * 探したいタグ(業種カテゴリー)のID
     * @example 1
     */
    id: number | null;
    /**
     * 業種親カテゴリー
     * @example "sample"
     */
    industryParentCode: string;
    /**
     * 業種子カテゴリー
     * @example "sample"
     */
    industryChildCode: string;
  }[];
  /**
   * 自社区分
   * @example ["startup","academia_startup"]
   */
  companyTypes?:
    | (
        | "npo"
        | "university"
        | "overseas_startup"
        | "partnership_within_6_months"
        | "local_challenge_company"
        | "partnership_within_3_months"
        | "academia_startup"
        | "overseas_capital"
        | "public_company"
        | "local_government"
        | "large_enterprise"
        | "medium_small_enterprise"
        | "startup"
        | "other_organization"
      )[]
    | null;
  /**
   * 企業ステージ
   * @example "early"
   */
  companyStage: "ipo" | "later" | "middle" | "early" | "seed" | "other" | null;
  /**
   * 本サービスの利用目的
   * @example ["business_partner","joint_development"]
   */
  servicePurposes:
    | (
        | "business_sale"
        | "business_acquisition"
        | "seeking_investment"
        | "interested_in_investment"
        | "co_creation_lab"
        | "joint_venture"
        | "business_partner"
        | "market_test"
        | "new_customer_expansion"
        | "networking"
        | "presentation_opportunity"
        | "tech_contest"
        | "idea_contest"
        | "limited_project"
        | "sales_channel"
        | "product_improvement"
        | "external_resources"
        | "tech_sharing"
        | "joint_development"
        | "research_collaboration"
      )[]
    | null;
}

/** 業務エラー(400エラー)の時に返却される共通のレスポンス */
export interface BusinessErrorResponse {
  /** @example "入力内容に誤りがあります。" */
  message?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:4002";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title SDGs 共創 Lodge API
 * @version 0.0.2
 * @baseUrl http://localhost:4002
 *
 * WebApiの仕様を記載する。
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  auth = {
    /**
     * @description ログインに成功した場合ユーザー情報を返却する
     *
     * @tags authentication
     * @name LoginEmailCreate
     * @summary メールアドレスでログインするAPI
     * @request POST:/auth/login/email
     */
    loginEmailCreate: (
      data: {
        /** @example "test@test.test" */
        email: string;
        /** @example "dflkgjhogioea9009" */
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 認証済みユーザー情報 */
          user: AuthenticatedUser;
          /** アクセストークン */
          token: AccessToken;
        },
        any
      >({
        path: `/auth/login/email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ログインに成功した場合ユーザー情報を返却する
     *
     * @tags authentication
     * @name LoginTokenCreate
     * @summary トークンでログインするAPI
     * @request POST:/auth/login/token
     */
    loginTokenCreate: (
      data: {
        /** @example "ABCDEFG-HIJKLMN-OPQRSTU-VWXYZ" */
        token: string;
        /** @example "ABCDEFG-HIJKLMN-OPQRSTU-VWXYZ" */
        userId: string;
        /** @example "ABCDEFG-HIJKLMN-OPQRSTU-VWXYZ" */
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 認証済みユーザー情報 */
          user: AuthenticatedUser;
          /** アクセストークン */
          token: AccessToken;
        },
        any
      >({
        path: `/auth/login/token`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ログアウトする。
     *
     * @tags authentication
     * @name LogoutCreate
     * @summary ログアウトAPI
     * @request POST:/auth/logout
     */
    logoutCreate: (params: RequestParams = {}) =>
      this.request<SuccessResponse, any>({
        path: `/auth/logout`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description 現在フロントで保持している認証情報の有効期限が切れているか確認する。ヘッダーのアクセストークンを使って認証情報を確認する。
     *
     * @tags authentication
     * @name CheckCreate
     * @summary 認証情報確認API
     * @request POST:/auth/check
     */
    checkCreate: (params: RequestParams = {}) =>
      this.request<
        {
          /** 認証済みユーザー情報 */
          user: AuthenticatedUser;
        },
        any
      >({
        path: `/auth/check`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags token
     * @name TokenDashboardCreate
     * @summary ダッシュボードに遷移するのに必要なトークン情報を取得する
     * @request POST:/auth/token/dashboard
     */
    tokenDashboardCreate: (
      data: {
        /** @example "XTRcetztgGCDOy7FuNAs" */
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "XTRcetztgGCDOy7FuNAs" */
          token: string;
          /** @example "XTRcetztgGCDOy7FuNAs" */
          userId: string;
        },
        any
      >({
        path: `/auth/token/dashboard`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  password = {
    /**
     * @description 入力されたメールアドレスに引き当たる共創ユーザーがいれば、入力メールアドレス宛にパスワードリセットを行うURLが入ったメールを送信する
     *
     * @tags passwords
     * @name ResetSendCreate
     * @summary パスワードリセットメールを送信するAPI
     * @request POST:/password/reset/send
     */
    resetSendCreate: (
      data: {
        /** @example "test@test.com" */
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "test@test.com" */
          email: string;
        },
        any
      >({
        path: `/password/reset/send`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description トークンからメールアドレスを取得する
     *
     * @tags passwords
     * @name GetEmailCreate
     * @summary トークンからメールアドレスを取得するAPI
     * @request POST:/password/get/email
     */
    getEmailCreate: (
      data: {
        /** @example "XTRcetztgGCDOy7FuNAs" */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "test@test.com" */
          email: string;
        },
        any
      >({
        path: `/password/get/email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description パスワードリセットを実行するAPI
     *
     * @tags passwords
     * @name ResetStoreCreate
     * @summary パスワードリセットAPI
     * @request POST:/password/reset/store
     */
    resetStoreCreate: (
      data: {
        /**
         * トークン
         * @example "test@test.com"
         */
        token: string;
        /**
         * メールアドレス
         * @example "test@test.com"
         */
        email: string;
        /**
         * パスワード
         * @example "xxxxxxxx"
         */
        password: string;
        /**
         * パスワード再入力
         * @example "XTRcetztgGCDOy7FuNAs"
         */
        password_confirmation: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/password/reset/store`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  contact = {
    /**
     * @description お問い合わせ内容のバリデーションチェックを行う
     *
     * @tags contact
     * @name ConfirmCreate
     * @summary お問い合わせ内容確認API
     * @request POST:/contact/confirm
     */
    confirmCreate: (data: ContactRequest, params: RequestParams = {}) =>
      this.request<SuccessResponse, ValidationErrorResponse>({
        path: `/contact/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description お問い合わせを送信してデータベースに保存する
     *
     * @tags contact
     * @name SendCreate
     * @summary お問い合わせ送信API
     * @request POST:/contact/send
     */
    sendCreate: (data: ContactRequest, params: RequestParams = {}) =>
      this.request<SuccessResponse, ValidationErrorResponse>({
        path: `/contact/send`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  faqs = {
    /**
     * @description 公開されているFAQ一覧を取得する
     *
     * @tags faq
     * @name FaqsList
     * @summary FAQ一覧取得API
     * @request GET:/faqs
     */
    faqsList: (params: RequestParams = {}) =>
      this.request<
        {
          data?: FaqItem[];
        },
        any
      >({
        path: `/faqs`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  guide = {
    /**
     * @description スタートアップガイドが完了しているか確認する。
     *
     * @tags guide
     * @name CheckList
     * @summary スタートアップガイド完了確認API
     * @request GET:/guide/check
     */
    checkList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example ["updateProfile","askAi","searchPartners"] */
          completedActions: string[];
        },
        any
      >({
        path: `/guide/check`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  business = {
    /**
     * No description
     *
     * @tags business
     * @name CheckGenerateLimitList
     * @summary 事業アイデア生成可能か確認するAPI
     * @request GET:/business/check/generate/limit
     */
    checkGenerateLimitList: (params: RequestParams = {}) =>
      this.request<
        {
          /**
           * 事業アイデア生成可能かどうか
           * @example true
           */
          enableGenerate: boolean;
          /**
           * 有料プランかどうか
           * @example true
           */
          isPaidPlan: boolean;
          /**
           * 残りの事業アイデア生成可能数
           * @example 50
           */
          remainCount: number | null;
        },
        any
      >({
        path: `/business/check/generate/limit`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 企業情報を基に事業アイデアを自動生成します。aiInstructionは任意の追加指示文で、nullでも送信可能です。
     *
     * @tags business
     * @name GenerateCreate
     * @summary 事業アイデアをAI自動生成するAPI
     * @request POST:/business/generate
     */
    generateCreate: (
      data: {
        /**
         * AI生成に対する追加指示文（任意）
         * @example "特に環境負荷の少ないソリューションを重視してください"
         */
        aiInstruction?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/business/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags business
     * @name GetBusiness
     * @summary 自分の事業アイデア一覧を取得するAPI
     * @request GET:/business/own
     */
    getBusiness: (
      query?: {
        /**
         * 取得開始位置
         * @default 0
         */
        cursor?: number;
        /**
         * 取得件数
         * @default 10
         */
        limit?: number;
        /**
         * ソート順
         * @default "createdAt"
         */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 50 */
          total: number;
          businessList: {
            /**
             * 事業アイデアID（KyousouBusinessIdeaのid）
             * @example "1"
             */
            businessIdeaId: string;
            /**
             * プロジェクト名（SlideBusinessAbstractのprojectNameから取得）
             * @example "廃棄プラスチックを活用したエコパッケージ開発"
             */
            projectName: string;
            /**
             * 事業内容の説明（SlideBusinessAbstractのbusinessContentFirstから取得）
             * @example "当社は、廃プラスチックを回収・再資源化し、環境配慮型の新素材としてパッケージを開発します。"
             */
            businessContentFirst: string;
            /** @example "大手製造会社としての資本力と流通力、海外販路の拡大、環境配慮型素材の供給" */
            keyPoint: string;
            /** @example 4 */
            evaluation: number;
            /**
             * 事業アイデアのユーザー評価
             * @example "good"
             */
            userEvaluation: "bad" | "good";
            /** おすすめ企業 */
            recommendationEnterprise: EnterpriseSummary;
          }[];
        },
        any
      >({
        path: `/business/own`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定された事業概要IDの詳細情報を取得する
     *
     * @tags business
     * @name SlideAbstractDetailList
     * @summary 事業概要の詳細を取得するAPI
     * @request GET:/business/slide/abstract/{businessIdeaId}/detail
     */
    slideAbstractDetailList: (
      businessIdeaId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 事業概要モデル */
          businessAbstract: SlideBusinessAbstract;
          /**
           * 事業アイデアのユーザー評価
           * @example "good"
           */
          userEvaluation?: "bad" | "good" | null;
        },
        any
      >({
        path: `/business/slide/abstract/${businessIdeaId}/detail`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 事業概要の情報を更新する
     *
     * @tags business
     * @name SlideAbstractUpdateUpdate
     * @summary 事業概要を更新するAPI
     * @request PUT:/business/slide/abstract/update
     */
    slideAbstractUpdateUpdate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * プロジェクト名
         * @example "修正後のプロジェクト名"
         */
        projectName?: string | null;
        /**
         * 市場背景
         * @example "修正後の市場背景"
         */
        marketBackground?: string | null;
        /**
         * 競合分析
         * @example "修正後の競合分析"
         */
        competitorAnalysis?: string | null;
        /**
         * ビジネスチャンス
         * @example "修正後のビジネスチャンス"
         */
        businessChance?: string | null;
        /**
         * 事業内容（1つ目）
         * @example "修正後の事業内容（1つ目）"
         */
        businessContentFirst?: string | null;
        /**
         * 事業内容（2つ目）
         * @example "修正後の事業内容（2つ目）"
         */
        businessContentSecond?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 事業概要モデル */
          businessAbstract: SlideBusinessAbstract;
        },
        any
      >({
        path: `/business/slide/abstract/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 現在のスライド内容とAI指示に基づいて事業概要を再生成する
     *
     * @tags business
     * @name SlideAbstractRegenerateCreate
     * @summary AI指示による事業概要再生成API
     * @request POST:/business/slide/abstract/regenerate
     */
    slideAbstractRegenerateCreate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * AIへの再生成指示
         * @example "もっと具体的な市場データを含めて、競合優位性をより明確にしてください"
         */
        aiInstruction: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 事業概要モデル */
          businessAbstract: SlideBusinessAbstract;
        },
        any
      >({
        path: `/business/slide/abstract/regenerate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定された3C分析IDの詳細情報を取得する
     *
     * @tags business
     * @name SlideThreecDetailList
     * @summary 3C分析の詳細を取得するAPI
     * @request GET:/business/slide/threec/{businessIdeaId}/detail
     */
    slideThreecDetailList: (
      businessIdeaId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 3C分析モデル */
          threeC: SlideThreeC;
        },
        any
      >({
        path: `/business/slide/threec/${businessIdeaId}/detail`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 3C分析の情報を更新する
     *
     * @tags business
     * @name SlideThreecUpdateUpdate
     * @summary 3C分析を更新するAPI
     * @request PUT:/business/slide/threec/update
     */
    slideThreecUpdateUpdate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /** ニーズの説明 */
        needs?: string | null;
        /** ターゲット層の1つ目の説明 */
        targetFirst?: string | null;
        /** ターゲット層の2つ目の説明 */
        targetSecond?: string | null;
        /** 市場トレンドの1つ目の説明 */
        marketTrendFirst?: string | null;
        /** 市場トレンドの2つ目の説明 */
        marketTrendSecond?: string | null;
        /** 主要競合の1つ目の説明 */
        mainCompetitorFirst?: string | null;
        /** 主要競合の2つ目の説明 */
        mainCompetitorSecond?: string | null;
        /** 優位性の1つ目の説明 */
        advantageFirst?: string | null;
        /** 優位性の2つ目の説明 */
        advantageSecond?: string | null;
        /** 差別化のヒントの1つ目の説明 */
        differentiationFirst?: string | null;
        /** 差別化のヒントの2つ目の説明 */
        differentiationSecond?: string | null;
        /** 自社の強みの1つ目の説明 */
        strengthFirst?: string | null;
        /** 自社の強みの2つ目の説明 */
        strengthSecond?: string | null;
        /** 自社の強みの3つ目の説明 */
        strengthThird?: string | null;
        /** リソースの1つ目の説明 */
        resourceFirst?: string | null;
        /** リソースの2つ目の説明 */
        resourceSecond?: string | null;
        /** 今後の戦略の1つ目の説明 */
        strategyFirst?: string | null;
        /** 今後の戦略の2つ目の説明 */
        strategySecond?: string | null;
        /** 今後の戦略の3つ目の説明 */
        strategyThird?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 3C分析モデル */
          threeC: SlideThreeC;
        },
        any
      >({
        path: `/business/slide/threec/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 現在のスライド内容とAI指示に基づいて3C分析を再生成する
     *
     * @tags business
     * @name SlideThreecRegenerateCreate
     * @summary AI指示による3C分析再生成API
     * @request POST:/business/slide/threec/regenerate
     */
    slideThreecRegenerateCreate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * AIへの再生成指示
         * @example "より具体的な競合企業名と市場データを含めて、自社の強みをより明確にしてください"
         */
        aiInstruction: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 3C分析モデル */
          threeC: SlideThreeC;
        },
        any
      >({
        path: `/business/slide/threec/regenerate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定された投資計画IDの詳細情報を取得する
     *
     * @tags business
     * @name SlideInvestmentDetailList
     * @summary 投資計画の詳細を取得するAPI
     * @request GET:/business/slide/investment/{businessIdeaId}/detail
     */
    slideInvestmentDetailList: (
      businessIdeaId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 投資計画モデル */
          investmentPlan: SlideInvestmentPlan;
        },
        any
      >({
        path: `/business/slide/investment/${businessIdeaId}/detail`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 投資計画の情報を更新する
     *
     * @tags business
     * @name SlideInvestmentUpdateUpdate
     * @summary 投資計画を更新するAPI
     * @request PUT:/business/slide/investment/update
     */
    slideInvestmentUpdateUpdate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * 収益構造の説明
         * @example "【更新済み】主力製品である生分解性パッケージの販売により、食品・化粧品業界を中心に安定した収益基盤を構築します。さらに、企業向けサステナビリティコンサルティング事業を展開し、多角化による収益の最大化を図ります。"
         */
        profitStructure?: string | null;
        /**
         * 収益項目のJSON配列
         * @example "[{"label":"【更新済み】生分解性パッケージ販売","value":"年間350億円"},{"label":"【更新済み】企業向けコンサルティング","value":"年阄80億円"},{"label":"【更新済み】ライセンス収入","value":"年阄25億円"},{"label":"【更新済み】メンテナンスサービス","value":"年阄15億円"}]"
         */
        profitStructureItems?: string | null;
        /**
         * キャッシュフロー計画の説明
         * @example "【更新済み】事業開始から3年間で黒字化を達成し、5年目には累積売上2000億円、営業利益率20%を目指します。初期投資の回収は4年目で完了予定です。"
         */
        cashFlow?: string | null;
        /**
         * キャッシュフロー項目のJSON配列
         * @example "[{"year":"1年目","sales":"【更新済み】120億円","operatingIncome":"【更新済み】-30億円","recovery":"【更新済み】-25%"},{"year":"2年目","sales":"【更新済み】280億円","operatingIncome":"【更新済み】35億円","recovery":"【更新済み】30%"},{"year":"3年目","sales":"【更新済み】450億円","operatingIncome":"【更新済み】90億円","recovery":"【更新済み】75%"},{"year":"4年目","sales":"【更新済み】580億円","operatingIncome":"【更新済み】145億円","recovery":"【更新済み】100%"},{"year":"5年目","sales":"【更新済み】720億円","operatingIncome":"【更新済み】210億円","recovery":"【更新済み】150%"}]"
         */
        cashFlowItems?: string | null;
        /**
         * 初期投資と財務計画の説明
         * @example "【更新済み】総投資額800億円の内訳は、研究開発費200億円、製造設備投資350億円、マーケティング費150億円、運転資金100億円です。資金調達は自己資金50%、銀行融資30%、投資家資金20%を予定しています。"
         */
        financialPlan?: string | null;
        /**
         * 財務計画項目のJSON配列
         * @example "[{"label":"【更新済み】研究開発費","value":"200億円"},{"label":"【更新済み】製造設備投資","value":"350億円"},{"label":"【更新済み】マーケティング費","value":"150億円"},{"label":"【更新済み】運転資金","value":"100億円"},{"label":"【更新済み】システム開発費","value":"50億円"}]"
         */
        financialPlanItems?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 投資計画モデル */
          investmentPlan: SlideInvestmentPlan;
        },
        any
      >({
        path: `/business/slide/investment/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 現在のスライド内容とAI指示に基づいて投資計画を再生成する
     *
     * @tags business
     * @name SlideInvestmentRegenerateCreate
     * @summary AI指示による投資計画再生成API
     * @request POST:/business/slide/investment/regenerate
     */
    slideInvestmentRegenerateCreate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * AIへの再生成指示
         * @example "より具体的な数値データと、5年間の詳細な収支計画を含めて投資計画を作成してください"
         */
        aiInstruction: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 投資計画モデル */
          investmentPlan: SlideInvestmentPlan;
        },
        any
      >({
        path: `/business/slide/investment/regenerate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定された実行計画&必要なリソースIDの詳細情報を取得する
     *
     * @tags business
     * @name SlideExecutionDetailList
     * @summary 実行計画&必要なリソースの詳細を取得するAPI
     * @request GET:/business/slide/execution/{businessIdeaId}/detail
     */
    slideExecutionDetailList: (
      businessIdeaId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 実行計画&必要なリソースモデル */
          executionPlan: SlideExecutionPlan;
        },
        any
      >({
        path: `/business/slide/execution/${businessIdeaId}/detail`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 実行計画&必要なリソースの情報を更新する
     *
     * @tags business
     * @name SlideExecutionUpdateUpdate
     * @summary 実行計画&必要なリソースを更新するAPI
     * @request PUT:/business/slide/execution/update
     */
    slideExecutionUpdateUpdate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * 必要なリソース説明文
         * @example "【更新済み】本プロジェクトの実行には、技術開発チーム（エンジニア5名、デザイナー2名）、マーケティングチーム（3名）、営業チーム（4名）の計14名の人員が必要です。初期投資として3,000万円、運転資金として月額500万円を見込んでいます。また、製造設備の確保、原材料の安定供給体制の構築、販売チャネルの開拓が重要な成功要因となります。"
         */
        resource?: string | null;
        /**
         * 最大期間数（1〜24）
         * @min 1
         * @max 24
         * @example 18
         */
        maxPeriod?: number | null;
        /**
         * スケジュール項目のJSON配列
         * @example "[{"label":"【更新済み】市場調査・要件定義","startPeriod":1,"endPeriod":3},{"label":"【更新済み】プロトタイプ開発","startPeriod":3,"endPeriod":6}]"
         */
        scheduleItems?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 実行計画&必要なリソースモデル */
          executionPlan: SlideExecutionPlan;
        },
        any
      >({
        path: `/business/slide/execution/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AIを使用して実行計画&必要なリソースの内容を再生成する
     *
     * @tags business
     * @name SlideExecutionRegenerateCreate
     * @summary 実行計画&必要なリソースをAI再生成するAPI
     * @request POST:/business/slide/execution/regenerate
     */
    slideExecutionRegenerateCreate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * AI再生成時の指示内容
         * @example "より具体的な実施時期と必要人員数を明確にして、実現可能性の高いスケジュールに修正してください"
         */
        aiInstruction: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** 実行計画&必要なリソースモデル */
          executionPlan: SlideExecutionPlan;
        },
        any
      >({
        path: `/business/slide/execution/regenerate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定されたFAQ・懸念点まとめIDの詳細情報を取得する
     *
     * @tags business
     * @name SlideFaqDetailList
     * @summary FAQ・懸念点まとめの詳細を取得するAPI
     * @request GET:/business/slide/faq/{businessIdeaId}/detail
     */
    slideFaqDetailList: (businessIdeaId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** FAQ・懸念点まとめモデル */
          faq: SlideFaq;
        },
        any
      >({
        path: `/business/slide/faq/${businessIdeaId}/detail`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description FAQ・懸念点まとめの情報を更新する
     *
     * @tags business
     * @name SlideFaqUpdateUpdate
     * @summary FAQ・懸念点まとめを更新するAPI
     * @request PUT:/business/slide/faq/update
     */
    slideFaqUpdateUpdate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * 懸念点と対応策のJSON配列
         * @example "[{"label":"【更新済み】環境への実質的な効果が薄い","value":"【更新済み】LCA分析による定量的効果測定と第三者認証取得により信頼性を担保"},{"label":"【更新済み】既存業界からの反発","value":"【更新済み】段階的移行支援プログラムの提供により既存事業者との共存を図る"}]"
         */
        concerns?: string | null;
        /**
         * FAQ項目のJSON配列
         * @example "[{"label":"【更新済み】投資回収期間はどの程度ですか？","value":"【更新済み】3年以内の完全回収を目標とし、最短2年での回収も可能な計画です"},{"label":"【更新済み】市場規模と成長性は？","value":"【更新済み】国内市場5,000億円、年平均成長率15%の急拡大市場です"}]"
         */
        faqs?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** FAQ・懸念点まとめモデル */
          faq: SlideFaq;
        },
        any
      >({
        path: `/business/slide/faq/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 現在のスライド内容とAI指示に基づいてFAQ・懸念点まとめを再生成する
     *
     * @tags business
     * @name SlideFaqRegenerateCreate
     * @summary AI指示によるFAQ・懸念点まとめ再生成API
     * @request POST:/business/slide/faq/regenerate
     */
    slideFaqRegenerateCreate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * AIへの再生成指示
         * @example "より具体的な数値データを含めて、投資家が気になるであろう懸念点を5つ追加し、それぞれに詳細な対応策を含めてください"
         */
        aiInstruction: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** FAQ・懸念点まとめモデル */
          faq: SlideFaq;
        },
        any
      >({
        path: `/business/slide/faq/regenerate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定されたオススメ共創パートナー企業IDの詳細情報を取得する
     *
     * @tags business
     * @name SlidePartnersDetailList
     * @summary オススメ共創パートナー企業の詳細を取得するAPI
     * @request GET:/business/slide/partners/{businessIdeaId}/detail
     */
    slidePartnersDetailList: (
      businessIdeaId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** オススメ共創パートナー企業モデル */
          partners: SlidePartners;
        },
        any
      >({
        path: `/business/slide/partners/${businessIdeaId}/detail`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description オススメ共創パートナー企業の情報を更新する
     *
     * @tags business
     * @name SlidePartnersUpdateUpdate
     * @summary オススメ共創パートナー企業を更新するAPI
     * @request PUT:/business/slide/partners/update
     */
    slidePartnersUpdateUpdate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * パートナー企業のJSON配列
         * @example "[{"thumbnailUrl":"https://picsum.photos/200","enterpriseName":"【更新済み】富士通株式会社","industryCategory":"【更新済み】製造業","evaluation":4,"enterpriseFeature":"【更新済み】廃プラスチックの回収・再資源化技術を持ち、高品質なリサイクル素材の提供に強みを持つ。独自の化学リサイクル技術を用いた高純度のプラスチック再生が可能。政府や大手メーカーとの連携実績あり。","advantage":"【更新済み】安定供給が可能であり、環境負荷を大幅に削減。補助金活用によるコスト低減も期待できる。"}]"
         */
        partners?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** オススメ共創パートナー企業モデル */
          partners: SlidePartners;
        },
        any
      >({
        path: `/business/slide/partners/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 現在のスライド内容とAI指示に基づいてオススメ共創パートナー企業を再生成する
     *
     * @tags business
     * @name SlidePartnersRegenerateCreate
     * @summary AI指示によるオススメ共創パートナー企業再生成API
     * @request POST:/business/slide/partners/regenerate
     */
    slidePartnersRegenerateCreate: (
      data: {
        /**
         * 事業アイデアID
         * @example "1"
         */
        businessIdeaId: string;
        /**
         * AIへの再生成指示
         * @example "製造業以外の業界も含めて、より多様なパートナー企業を6社提案してください。特にIT・テクノロジー系の企業も含めてください。"
         */
        aiInstruction: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** オススメ共創パートナー企業モデル */
          partners: SlidePartners;
        },
        any
      >({
        path: `/business/slide/partners/regenerate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 事業アイデアにユーザー評価をつける。
     *
     * @tags business
     * @name EvaluationCreate
     * @summary 事業アイデアに評価をつけるAPI
     * @request POST:/business/{businessIdeaId}/evaluation
     */
    evaluationCreate: (
      businessIdeaId: string,
      data: {
        /**
         * 事業アイデアのユーザー評価
         * @example "good"
         */
        evaluation: "bad" | "good";
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/business/${businessIdeaId}/evaluation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 事業アイデアを削除する
     *
     * @tags business
     * @name DeleteCreate
     * @summary 事業アイデアを削除するAPI
     * @request POST:/business/{businessIdeaId}/delete
     */
    deleteCreate: (businessIdeaId: string, params: RequestParams = {}) =>
      this.request<SuccessResponse, any>({
        path: `/business/${businessIdeaId}/delete`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  partnerRecruitments = {
    /**
     * No description
     *
     * @tags partner
     * @name PartnerRecruitmentsList
     * @summary パートナー募集を取得するAPI
     * @request GET:/partner-recruitments
     */
    partnerRecruitmentsList: (
      query?: {
        /**
         * 取得開始位置
         * @default 0
         */
        cursor?: number;
        /**
         * 取得件数
         * @default 100
         */
        limit?: number;
        /**
         * ソート順
         * @default "createdAt"
         */
        sort?: string;
        /** ステータスフィルター */
        status?: "draft" | "published" | "scheduled";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          partnerRecruitments: PartnerRecruitment[];
        },
        any
      >({
        path: `/partner-recruitments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 新しいパートナー募集を作成する
     *
     * @tags partner
     * @name PartnerRecruitmentsCreate
     * @summary パートナー募集を作成するAPI
     * @request POST:/partner-recruitments
     */
    partnerRecruitmentsCreate: (
      data: {
        /** 募集タイトル（下書きの場合はオプショナル） */
        title?: string;
        /** 募集内容の説明（下書きの場合はオプショナル） */
        description?: string;
        /** 応募要件 */
        requirements?: string;
        /** 法的事項 */
        legalMatters?: string;
        /** サムネイル画像URL */
        thumbnailUrl?: string;
        /** ステータス */
        status?: "draft" | "published" | "scheduled";
        /** SDGsカテゴリ */
        sdgsCategories?: string[];
        /**
         * 予約投稿日時
         * @format date-time
         */
        scheduledDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** パートナー募集情報 */
          partnerRecruitment: PartnerRecruitment;
        },
        ValidationErrorResponse
      >({
        path: `/partner-recruitments`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ログイン中企業のパートナー募集一覧を取得する（認証必要）
     *
     * @tags partner
     * @name GetPartnerRecruitments
     * @summary 自社パートナー募集一覧取得API
     * @request GET:/partner-recruitments/my
     */
    getPartnerRecruitments: (
      query?: {
        /**
         * ページ番号
         * @default 1
         */
        page?: number;
        /**
         * 1ページあたりの取得件数
         * @default 30
         */
        per_page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          partnerRecruitments: PartnerRecruitment[];
        },
        any
      >({
        path: `/partner-recruitments/my`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定されたIDのパートナー募集詳細を取得する
     *
     * @tags partner
     * @name PartnerRecruitmentsDetail
     * @summary パートナー募集詳細を取得するAPI
     * @request GET:/partner-recruitments/{id}
     */
    partnerRecruitmentsDetail: (id: string, params: RequestParams = {}) =>
      this.request<PartnerRecruitment, void>({
        path: `/partner-recruitments/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 既存のパートナー募集を更新する
     *
     * @tags partner
     * @name PartnerRecruitmentsUpdate
     * @summary パートナー募集を更新するAPI
     * @request PUT:/partner-recruitments/{id}
     */
    partnerRecruitmentsUpdate: (
      id: string,
      data: {
        /**
         * 募集タイトル
         * @example "共創パートナー募集"
         */
        title: string;
        /**
         * 募集内容の説明
         * @example "一緒にSDGsに取り組むパートナーを募集しています"
         */
        description: string;
        /**
         * 応募要件
         * @example "SDGsに関心がある企業"
         */
        requirements?: string;
        /**
         * 法的事項
         * @example "契約条件については個別に相談"
         */
        legalMatters?: string;
        /**
         * サムネイル画像URL
         * @example "https://example.com/image.jpg"
         */
        thumbnailUrl?: string;
        /**
         * ステータス
         * @example "published"
         */
        status?: "draft" | "published" | "scheduled";
        /**
         * 予約投稿日時（statusがscheduledの場合必須）
         * @format date-time
         * @example "2024-12-31T10:00:00Z"
         */
        scheduledDate?: string;
        /**
         * SDGsカテゴリ
         * @example ["1","2","3"]
         */
        sdgsCategories?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** パートナー募集情報 */
          partnerRecruitment: PartnerRecruitment;
        },
        ValidationErrorResponse | void
      >({
        path: `/partner-recruitments/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags partner
     * @name RequestCreate
     * @summary パートナー募集に応募するAPI
     * @request POST:/partner-recruitments/request/{partnerRecruitmentId}
     */
    requestCreate: (
      partnerRecruitmentId: string,
      data: {
        /** @example "応募メッセージ" */
        message: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/partner-recruitments/request/${partnerRecruitmentId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  enterprise = {
    /**
     * @description 企業が会員登録する前にメールを送信する
     *
     * @tags enterprise
     * @name RegisterMailCreate
     * @summary 企業登録前のメール送信API
     * @request POST:/enterprise/register/mail
     */
    registerMailCreate: (
      data: {
        /**
         * メールアドレス
         * @example "enterprise@enterprise.com"
         */
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/enterprise/register/mail`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 企業会員登録URLのトークンをチェックする
     *
     * @tags enterprise
     * @name RegisterTokenCheckCreate
     * @summary 企業会員登録URLのトークンをチェックするAPI
     * @request POST:/enterprise/register/token/check
     */
    registerTokenCheckCreate: (
      data: {
        /**
         * トークン
         * @example "AlknmcaprDSDFsdvmcwafoSwqg"
         */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "test@test.com" */
          email: string;
        },
        any
      >({
        path: `/enterprise/register/token/check`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 企業の新規登録
     *
     * @tags enterprise
     * @name RegisterCreate
     * @summary 企業を作成するAPI
     * @request POST:/enterprise/register
     */
    registerCreate: (
      data: {
        /** @example "トークン" */
        token: string;
        /** @example "サンプル株式会社" */
        name: string;
        /** @example "クチコミ１サンプル株式会社です。" */
        description?: string;
        /** @example "サンプル" */
        delegateLastName: string;
        /** @example "サンプル" */
        delegateFirstName: string;
        /** @example "サンプル" */
        delegatePosition: string;
        /** @example "サンプル" */
        responsiblePersonName: string;
        /** @example "2024-04-01" */
        establishDate: string;
        /** @example "東京都" */
        prefecture: string;
        /** @example "000-0000" */
        postCode: string;
        /** @example "東京都中央区0-00-0" */
        address: string;
        /** @example "000-0000-000" */
        tel: string;
        /** @example "000-0000" */
        stockCode?: string;
        /** @example 1000000 */
        capitalPrice?: number | null;
        /** @example 1000 */
        employeeNum?: number | null;
        /** @example "sample" */
        industryParentCode: string;
        /** @example "sample" */
        industryChildCode: string;
        /** @example "sample" */
        enterpriseCode: string;
        businessCode: string[];
        businessChildCode: string[];
        sdgsCategory: string[];
        /** @example "https://picsum.photos/200" */
        logoUrl: string;
        /** @example "https://picsum.photos/200" */
        officialUrl?: string;
        /** @example "https://picsum.photos/200" */
        twitterUrl?: string;
        /** @example "https://picsum.photos/200" */
        facebookUrl?: string;
        /** @example "https://picsum.photos/200" */
        lineUrl?: string;
        /** @example "https://picsum.photos/200" */
        tiktokUrl?: string;
        /** @example true */
        publicDisplayFlag: boolean;
        /** @example "sample@sample.jp" */
        email: string;
        /** @example "sample000A!" */
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/enterprise/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name EnterpriseList
     * @summary 企業を取得するAPI
     * @request GET:/enterprise
     */
    enterpriseList: (
      query?: {
        /**
         * 取得開始位置
         * @default 0
         */
        cursor?: number;
        /**
         * 取得件数
         * @default 100
         */
        limit?: number;
        /**
         * キーワード
         * @default ""
         */
        keyword?: string;
        /**
         * 企業カテゴリ
         * @default "all"
         */
        enterpriseCategory?: string;
        /**
         * ビジネスカテゴリ
         * @default "all"
         */
        businessCategory?: string;
        /**
         * 住所
         * @default ""
         */
        address?: string;
        /**
         * 企業規模
         * @default ""
         */
        companySize?: string;
        /**
         * 資本金
         * @default ""
         */
        capital?: string;
        /**
         * SDGsカテゴリ
         * @default []
         */
        sdgsCategories?: string[];
        /**
         * ソート順
         * @default "createdAt"
         */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total: number;
          enterprises: EnterpriseSummary[];
        },
        any
      >({
        path: `/enterprise`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定された企業IDの詳細情報を取得する
     *
     * @tags enterprise
     * @name EnterpriseDetail
     * @summary 企業詳細を取得するAPI
     * @request GET:/enterprise/{enterpriseId}
     */
    enterpriseDetail: (enterpriseId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** 企業詳細情報 */
          detail?: EnterpriseDetail;
          /** 企業情報 */
          enterpriseSummary?: EnterpriseSummary;
        },
        BusinessErrorResponse
      >({
        path: `/enterprise/${enterpriseId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name FavoriteListList
     * @summary お気に入りの企業を取得するAPI
     * @request GET:/enterprise/favorite/list
     */
    favoriteListList: (
      query?: {
        /**
         * 取得開始位置
         * @default 0
         */
        cursor?: number;
        /**
         * 取得件数
         * @default 100
         */
        limit?: number;
        /**
         * ソート順
         * @default "createdAt"
         */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total: number;
          enterprises: EnterpriseSummary[];
        },
        any
      >({
        path: `/enterprise/favorite/list`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name FavoriteCreate
     * @summary 企業お気に入りAPI
     * @request POST:/enterprise/favorite
     */
    favoriteCreate: (
      data: {
        /** @example 2 */
        kuchikomiEnterpriseId: string;
        /** @example true */
        set: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/enterprise/favorite`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name MatchingListList
     * @summary マッチング中の企業を取得するAPI
     * @request GET:/enterprise/matching/list
     */
    matchingListList: (
      query?: {
        /**
         * 取得開始位置
         * @default 0
         */
        cursor?: number;
        /**
         * 取得件数
         * @default 10
         */
        limit?: number;
        /**
         * ソート順
         * @default "matchingRate"
         */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total: number;
          enterprises: (EnterpriseSummary & {
            /** @example "idea" */
            matchingFrom: "idea" | "partner" | "enterprise";
          })[];
        },
        any
      >({
        path: `/enterprise/matching/list`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name MatchingRequestCreate
     * @summary 企業にマッチングリクエストを送るAPI
     * @request POST:/enterprise/matching/request/{enterpriseId}
     */
    matchingRequestCreate: (
      enterpriseId: string,
      data: {
        /** @example "マッチングリクエストメッセージ" */
        message: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/enterprise/matching/request/${enterpriseId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name MatchingRequestAcceptCreate
     * @summary 企業にマッチングリクエストを承認するAPI
     * @request POST:/enterprise/matching/request/{enterpriseId}/accept/{matchingRequestId}
     */
    matchingRequestAcceptCreate: (
      enterpriseId: string,
      matchingRequestId: string,
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/enterprise/matching/request/${enterpriseId}/accept/${matchingRequestId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name MatchingRequestDeclineCreate
     * @summary 企業にマッチングリクエストを拒否するAPI
     * @request POST:/enterprise/matching/request/{enterpriseId}/decline/{matchingRequestId}
     */
    matchingRequestDeclineCreate: (
      enterpriseId: string,
      matchingRequestId: string,
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/enterprise/matching/request/${enterpriseId}/decline/${matchingRequestId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name MatchingRequestStatusList
     * @summary 企業にマッチングリクエストのステータスを取得するAPI
     * @request GET:/enterprise/matching/request/{enterpriseId}/status
     */
    matchingRequestStatusList: (
      enterpriseId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * マッチングリクエストのステータス
           * @example "pending"
           */
          status: "pending" | "accepted" | "rejected" | "none" | "forbidden";
        },
        any
      >({
        path: `/enterprise/matching/request/${enterpriseId}/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags enterprise
     * @name UpdateUpdate
     * @summary 企業詳細を更新するAPI
     * @request PUT:/enterprise/update
     */
    updateUpdate: (
      data: {
        /** @example "1" */
        kuchikomiEnterpriseId: string;
        /** @example "企業・団体名" */
        name?: string | null;
        /** @example "企業・団体説明" */
        description?: string | null;
        /** @example "代表者姓" */
        delegateLastName?: string | null;
        /** @example "代表者名" */
        delegateFirstName?: string | null;
        /** @example "代表者役職" */
        delegatePosition?: string | null;
        /** @example "2000-01-01" */
        establishDate?: string | null;
        /** @example "東京都" */
        prefecture?: string | null;
        /** @example "1234567" */
        postCode?: string | null;
        /** @example "渋谷区1-1-1" */
        address?: string | null;
        /** @example "03-1234-5678" */
        tel?: string | null;
        /** @example "1234" */
        stockCode?: string | null;
        /** @example 10000000 */
        capitalPrice?: number | null;
        /** @example 100 */
        employeeNum?: number | null;
        /** @example "https://example.com/logo.jpg" */
        logoUrl?: string | null;
        /** @example "https://example.com" */
        officialUrl?: string | null;
        /** @example "https://twitter.com/example" */
        twitterUrl?: string | null;
        /** @example "https://facebook.com/example" */
        facebookUrl?: string | null;
        /** @example "https://line.me/R/ti/p/@example" */
        lineUrl?: string | null;
        /** @example "https://www.tiktok.com/@example" */
        tiktokUrl?: string | null;
        /** @example "sample" */
        industryParentCode?: string | null;
        /** @example "sample" */
        industryChildCode?: string | null;
        /** @example "sample" */
        enterpriseCode?: string | null;
        /** @example ["sample1","sample2"] */
        businessCode?: string[] | null;
        /** @example ["sample1","sample2"] */
        businessChildCode?: string[] | null;
        /** @example ["1","2","3"] */
        sdgsCategory?: string[] | null;
        /** @example "https://example.com/banner.jpg" */
        bannerImageUrl?: string | null;
        topImages?: {
          /**
           * 既存のレコードのID（新規の場合はnull）
           * @example 1
           */
          id?: number | null;
          /** @example "https://example.com/top-image.jpg" */
          imageUrl?: string;
          /**
           * 表示順
           * @example 1
           */
          sortOrder?: number;
        }[];
        /** @example "企業概要テキスト" */
        companyProfile?: string | null;
        /** @example "自社特徴HTML" */
        companyFeature?: string | null;
        /** @example "提供リソースHTML" */
        providedResource?: string | null;
        /** @example "主要顧客HTML" */
        majorCustomer?: string | null;
        /** @example "株主情報HTML" */
        shareholder?: string | null;
        openInnovationAchievements?: {
          /**
           * 既存のレコードのID（新規の場合はnull）
           * @example 1
           */
          id?: number | null;
          /** @example "https://example.com/image.jpg" */
          imageUrl?: string | null;
          /** @example "オープンイノベーション実績HTML" */
          content?: string | null;
        }[];
        /** @example "再生可能エネルギーHTML" */
        renewableEnergy?: string | null;
        /** @example "エネルギー効率HTML" */
        energyEfficiency?: string | null;
        /** @example "環境教育HTML" */
        environmentalEducation?: string | null;
        /** @example "SDGs情報HTML" */
        sdgsInfo?: string | null;
        /** @example "共創タイトル" */
        coCreationTitle?: string | null;
        /** @example "共創内容HTML" */
        coCreationContent?: string | null;
        /** @example "解決したい課題HTML" */
        issue?: string | null;
        /** @example "共創で実現したいことHTML" */
        goal?: string | null;
        /** @example "求めている条件HTML" */
        requirement?: string | null;
        /** @example "部署名" */
        departmentName?: string | null;
        /** @example "責任者姓" */
        responsibleLastName?: string | null;
        /** @example "責任者名" */
        responsibleFirstName?: string | null;
        /** @example "責任者役職" */
        responsiblePosition?: string | null;
        /** @example "https://example.com/profile.jpg" */
        responsibleProfileImg?: string | null;
        /** @example "責任者自己紹介" */
        responsibleIntroduction?: string | null;
        /** @example "責任者ミッション" */
        responsibleMission?: string | null;
        /** @example "責任者コメント" */
        responsibleComment?: string | null;
        /** @example "部署説明" */
        departmentDescription?: string | null;
        /** 探したいタグ */
        searchIndustryCategories?: {
          /**
           * 探したいタグ(業種カテゴリー)のID
           * @example 1
           */
          id: number | null;
          /**
           * 業種親カテゴリー
           * @example "sample"
           */
          industryParentCode: string;
          /**
           * 業種子カテゴリー
           * @example "sample"
           */
          industryChildCode: string;
        }[];
        /**
         * 自社区分
         * @example ["startup","academia_startup"]
         */
        companyTypes?: string[] | null;
        /**
         * 企業ステージ
         * @example "early"
         */
        companyStage?: string | null;
        /**
         * 本サービスの利用目的
         * @example ["business_partner","joint_development"]
         */
        servicePurposes?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponse, any>({
        path: `/enterprise/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定された企業IDの関連企業一覧を取得する
     *
     * @tags enterprise
     * @name RelatedList
     * @summary 企業の関連企業を取得するAPI
     * @request GET:/enterprise/{enterpriseId}/related
     */
    relatedList: (enterpriseId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** 関連企業一覧 */
          relatedEnterprises: RelatedEnterprise[];
        },
        BusinessErrorResponse
      >({
        path: `/enterprise/${enterpriseId}/related`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  chat = {
    /**
     * @description チャット可能な企業の一覧を取得する
     *
     * @tags chat
     * @name RoomsList
     * @summary チャット部屋一覧を取得するAPI
     * @request GET:/chat/rooms
     */
    roomsList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example 8 */
          total: number;
          /** @example "jksjlfiajildsa" */
          token: string;
          rooms: ChatRoom[];
        },
        any
      >({
        path: `/chat/rooms`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 指定されたチャットルームIDのメッセージを送信する（contentまたはattachmentsのいずれかが必須）
     *
     * @tags chat
     * @name RoomsMessagesCreate
     * @summary 特定のチャットルームのメッセージを送信するAPI
     * @request POST:/chat/rooms/{chatRoomId}/messages
     */
    roomsMessagesCreate: (
      chatRoomId: number,
      data: {
        /**
         * メッセージ内容（任意。ただしattachmentsが空の場合は必須）
         * @example "おはようございます。先日お話しした再生可能エネルギープロジェクトの件ですが、弊社内で検討した結果、ぜひ協力させていただきたいと思います。"
         */
        content?: string | null;
        /** 添付ファイル（任意。ただしcontentが空の場合は必須） */
        attachments?:
          | {
              /** @example "https://picsum.photos/200" */
              url: string;
              /** @example "sample.jpg" */
              fileName: string;
            }[]
          | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "メッセージを送信しました" */
          message: string;
        },
        any
      >({
        path: `/chat/rooms/${chatRoomId}/messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 指定されたメッセージを削除する（自分が送信したメッセージのみ）
     *
     * @tags chat
     * @name RoomsMessagesDelete
     * @summary メッセージを削除するAPI
     * @request DELETE:/chat/rooms/{chatRoomId}/messages/{messageId}
     */
    roomsMessagesDelete: (
      chatRoomId: number,
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "メッセージを削除しました" */
          message: string;
        },
        any
      >({
        path: `/chat/rooms/${chatRoomId}/messages/${messageId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description 指定されたチャットルームを既読にする（last_read_atを現在時刻で更新）
     *
     * @tags chat
     * @name RoomsReadCreate
     * @summary チャットルームを既読にするAPI
     * @request POST:/chat/rooms/{chatRoomId}/read
     */
    roomsReadCreate: (chatRoomId: number, params: RequestParams = {}) =>
      this.request<SuccessResponse, any>({
        path: `/chat/rooms/${chatRoomId}/read`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  upload = {
    /**
     * No description
     *
     * @tags upload
     * @name ImageCreate
     * @summary 画像をアップロードする
     * @request POST:/upload/image
     */
    imageCreate: (
      data: {
        /**
         * アップロードする画像ファイル（jpg, jpeg, png）
         * @format binary
         */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "https://storage.googleapis.com/example/image.jpg" */
          url: string;
          /** @example "プロジェクト資料.jpg" */
          fileName: string;
        },
        any
      >({
        path: `/upload/image`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags upload
     * @name FileCreate
     * @summary ファイルをアップロードする（画像以外）
     * @request POST:/upload/file
     */
    fileCreate: (
      data: {
        /**
         * アップロードするファイル（pdf, doc, docx, xls, xlsx, zip, rar, txt, csv, ppt, pptx, mp4, mov, avi, wmv, webm）
         * @format binary
         */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "https://storage.googleapis.com/example/document.pdf" */
          url: string;
          /** @example "事業計画について.xlsx" */
          fileName: string;
        },
        any
      >({
        path: `/upload/file`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  stat = {
    /**
     * No description
     *
     * @tags stat
     * @name StatList
     * @summary 統計情報を取得するAPI
     * @request GET:/stat
     */
    statList: (
      query?: {
        /**
         * 取得開始日
         * @default "2025-06-27"
         */
        start?: string;
        /**
         * 取得終了日
         * @default "2025-06-27"
         */
        end?: string;
        /**
         * カテゴリ
         * @default "all"
         */
        category?: "all" | "new" | "repeat";
        /**
         * 取得開始位置
         * @default 0
         */
        cursor?: number;
        /**
         * 取得件数
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * 総企業数
           * @example 15
           */
          total: number;
          /**
           * 総訪問回数
           * @example 100
           */
          displayCount: number;
          /**
           * 訪問企業数
           * @example 100
           */
          displayEnterpriseCount: number;
          /**
           * 平均マッチング率
           * @example 85
           */
          matchingRate: number;
          checkedEnterprises: {
            /**
             * 訪問回数
             * @example 2
             */
            displayCount: number;
            /**
             * 滞在時間
             * @example "10分以上"
             */
            stayTimeText: string;
            /**
             * 最終訪問日時
             * @format date-time:YYYY-MM-DD HH:mm:ss
             * @example "2025-06-27 10:00:00"
             */
            latestDisplayAt: string;
            /** 企業情報 */
            enterprise: EnterpriseSummary;
          }[];
        },
        any
      >({
        path: `/stat`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 企業詳細ページへの訪問を記録する。認証されたユーザーのみ記録可能で、自分以外の企業への訪問のみ記録される。 - 初回訪問時: visitorStatIdなしで送信 → レスポンスでvisitorStatIdを受け取る - 2回目以降: 受け取ったvisitorStatIdを含めて送信 → 同じレコードに滞在時間が加算される - 前回の更新から2分以上経過している場合: 新規レコードが作成され、新しいvisitorStatIdが返却される
     *
     * @tags stat
     * @name RecordCreate
     * @summary 企業ページ訪問記録API
     * @request POST:/stat/record
     */
    recordCreate: (
      data: {
        /**
         * 訪問した企業のID
         * @example "123"
         */
        visitedEnterpriseId: string;
        /**
         * 滞在時間（秒）
         * @example 60
         */
        stayDuration: number;
        /**
         * 訪問統計レコードID（2回目以降の送信時に指定）
         * @example 456
         */
        visitorStatId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * 訪問統計レコードID（次回送信時に使用）
           * @example 456
           */
          visitorStatId: string;
        },
        any
      >({
        path: `/stat/record`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
